module.exports = __webpack_public_path__ + "img/hp-v3.3694a1f5.svg";